import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export const FAQSection = () => {
  const faqs = [{
    question: 'How do I use the Sleep Restore strips?',
    answer: 'Simply place one strip on your tongue and let it dissolve. The mint-flavored strip will quickly dissolve, delivering 5mg of melatonin. Take it 30-60 minutes before bedtime for best results.'
  }, {
    question: 'Is melatonin safe for long-term use?',
    answer: "Yes. Unlike sleeping pills, melatonin is the same hormone your body naturally produces. Clinical studies show it's safe for extended use without dependency issues."
  }, {
    question: 'Will I become dependent on melatonin?',
    answer: "No. Melatonin doesn't create physical dependence like sleeping pills do. Your body continues producing its own melatonin, and you can stop anytime without withdrawal symptoms."
  }, {
    question: 'How quickly does it work?',
    answer: 'Most people feel drowsy within 30-60 minutes. For best results, take it at the same time each night to help regulate your sleep cycle.'
  }, {
    question: 'What if I wake up feeling groggy?',
    answer: "This is rare with the proper 5mg dose in Setu's Sleep Restore strips. If you feel groggy, you might be taking it too late. Take it 2-3 hours before your desired bedtime."
  }, {
    question: 'Can I take it with other medications?',
    answer: "Melatonin is generally safe, but always consult your doctor if you're on other medications, especially blood thinners or diabetes medications."
  }, {
    question: 'How is this different from other melatonin brands?',
    answer: 'Setu Sleep Restore uses pharmaceutical-grade, plant-derived melatonin (5mg) in convenient mint-flavored strips. Our strips are tested for purity and potency, ensuring consistent results.'
  }, {
    question: "What if it doesn't work for me?",
    answer: "We offer a 30-day money-back guarantee. If you don't experience better sleep within a month, we'll refund your full purchase price."
  }];
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="w-full bg-gray-50 py-16 md:py-24" id="faq" data-id="element-233">
      <div className="container mx-auto px-4 md:px-6" data-id="element-234">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-12" data-id="element-235">
          Your Questions, Answered
        </h2>
        <div className="max-w-3xl mx-auto" data-id="element-236">
          {faqs.map((faq, index) => <div key={index} className={`mb-4 bg-white rounded-lg shadow-sm overflow-hidden ${openIndex === index ? 'border-l-4 border-indigo-500' : ''}`} data-id="element-237">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFAQ(index)} data-id="element-238">
                <span className="font-medium text-gray-900" data-id="element-239">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-indigo-600" data-id="element-240" /> : <ChevronDownIcon className="h-5 w-5 text-gray-600" data-id="element-241" />}
              </button>
              {openIndex === index && <div className="px-6 pb-4" data-id="element-242">
                  <p className="text-gray-700" data-id="element-243">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
};